import React, { useEffect } from 'react';
import { useGameStore } from '../stores/gameStore';

const TYPE_COLORS: Record<string, string> = {
  info: '#818cf8',
  success: '#4af0c4',
  warning: '#fbbf24',
  pvp: '#f87171',
};

export function NotificationToast() {
  const { notificationQueue, dismissNotification } = useGameStore();

  // Auto-dismiss after 5s
  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = [];
    for (const n of notificationQueue) {
      timers.push(setTimeout(() => dismissNotification(n.id), 5000));
    }
    return () => timers.forEach(clearTimeout);
  }, [notificationQueue, dismissNotification]);

  if (notificationQueue.length === 0) return null;

  return (
    <div style={styles.container}>
      {notificationQueue.slice(-4).map((n) => (
        <div
          key={n.id}
          style={{ ...styles.toast, borderLeftColor: TYPE_COLORS[n.type] }}
          onClick={() => dismissNotification(n.id)}
        >
          {n.message}
        </div>
      ))}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed',
    bottom: 16,
    right: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    zIndex: 999,
    pointerEvents: 'none',
  },
  toast: {
    padding: '8px 12px',
    background: 'rgba(13,21,32,0.95)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderLeft: '3px solid',
    borderRadius: 4,
    fontSize: 12,
    color: '#c8d8f0',
    maxWidth: 280,
    cursor: 'pointer',
    pointerEvents: 'all',
    backdropFilter: 'blur(8px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
  },
};
